export default [
    {
        path: '/',
        meta: {
            requiresAuth: true,
            role: 'admin',
            layout: 'AdminLayout',
        },
        children: [
            {
                path: '/hoteliers-dashboard',
                name: 'hoteliers-dashboard',
                component: () => import('@/Pages/Dashboard.vue'),
            },
            {
                path: '/hotel-performance',
                component: () => import('@/Pages/Hotel/HotelPerformance/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'hotel-performance',
                        component: () => import('@/Pages/Hotel/HotelPerformance/List.vue'),
                    },
                    {
                        path: 'create',
                        name: 'hotel-performance-create',
                        component: () => import('@/Pages/Hotel/HotelPerformance/Create.vue'),
                    },
                    {
                        path: ':id',
                        name: 'hotel-performance-show',
                        component: () => import('@/Pages/Hotel/HotelPerformance/Show.vue'),
                    },
                    {
                        path: ':id/edit',
                        name: 'hotel-performance-edit',
                        component: () => import('@/Pages/Hotel/HotelPerformance/Edit.vue'),
                    }
                ]
            },
            {
                path: '/hotel-reporting',
                name: 'hotel-reporting',
                component: () => import('@/Pages/Hotel/HotelReport/Index.vue'),
            },
            {
                path: '/hotel-profile',
                name: 'hotel-profile',
                component: () => import('@/Pages/Hotel/HotelProfile/Show.vue'),
            },
            {
                path: '/hotel-inventory',
                component: () => import('@/Pages/Hotel/HotelInventory/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'hotel-inventory',
                        component: () => import('@/Pages/Hotel/HotelInventory/List.vue'),
                    },
                    {
                        path: 'create',
                        name: 'hotel-inventory-create',
                        component: () => import('@/Pages/Hotel/HotelInventory/Create.vue'),
                    },
                    {
                        path: ':id',
                        name: 'hotel-inventory-show',
                        component: () => import('@/Pages/Hotel/HotelInventory/Show.vue'),
                    },
                    {
                        path: ':id/edit',
                        name: 'hotel-inventory-edit',
                        component: () => import('@/Pages/Hotel/HotelInventory/Edit.vue'),
                    }
                ]
            },
            {
                path: '/employee',
                component: () => import('@/Pages/Hotel/Employee/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'employee',
                        component: () => import('@/Pages/Hotel/Employee/List.vue'),
                    },
                    {
                        path: 'create',
                        name: 'employee-create',
                        component: () => import('@/Pages/Hotel/Employee/Create.vue'),
                    },
                    {
                        path: ':id',
                        name: 'employee-show',
                        component: () => import('@/Pages/Hotel/Employee/Show.vue'),
                    },
                    {
                        path: ':id/edit',
                        name: 'employee-edit',
                        component: () => import('@/Pages/Hotel/Employee/Edit.vue'),
                    }
                ]
            },
            {
                path: '/hoteliers-user',
                component: () => import('@/Pages/Hotel/User/Index.vue'),
                children: [
                    {
                        path: '',
                        name: 'hoteliers-user',
                        component: () => import('@/Pages/Hotel/User/List.vue'),
                    },
                    {
                        path: 'create',
                        name: 'hoteliers-user-create',
                        component: () => import('@/Pages/Hotel/User/Create.vue'),
                    },
                    {
                        path: ':id',
                        name: 'hoteliers-user-show',
                        component: () => import('@/Pages/Hotel/User/Show.vue'),
                    },
                    {
                        path: ':id/edit',
                        name: 'hoteliers-user-edit',
                        component: () => import('@/Pages/Hotel/User/Edit.vue'),
                    }
                ]
            },
            {
                path: "/hoteliers-role",
                component: () => import("@/Pages/Hotel/Role/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "hoteliers-role",
                        component: () => import("@/Pages/Hotel/Role/List.vue"),
                    },
                    {
                        path: "create",
                        name: "hoteliers-role-create",
                        component: () =>
                            import("@/Pages/Hotel/Role/Create.vue"),
                    },
                    {
                        path: ":id",
                        name: "hoteliers-role-show",
                        component: () => import("@/Pages/Hotel/Role/Show.vue"),
                    },
                    {
                        path: ":id/edit",
                        name: "hoteliers-role-edit",
                        component: () => import("@/Pages/Hotel/Role/Edit.vue"),
                    },
                ],
            },
            {
                path: "/hoteliers-room-type",
                component: () => import("@/Pages/Master/RoomType/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "hoteliers-room-type",
                        component: () => import("@/Pages/Master/RoomType/List.vue"),
                    },
                ],
            },
            {
                path: "/hoteliers-bed-type",
                component: () => import("@/Pages/Master/BedType/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "hoteliers-bed-type",
                        component: () => import("@/Pages/Master/BedType/List.vue"),
                    },
                ],
            },
            {
                path: "/hotel-location",
                component: () => import("@/Pages/Hotel/HotelLocation/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "hotel-location",
                        component: () => import("@/Pages/Hotel/HotelLocation/List.vue"),
                    },
                ],
            },
        ]
    }

]
